import { CONTACT } from "@/config/contact";

/**
 * Build a Schema.org BreadcrumbList JSON-LD string.
 * Pass the breadcrumb trail as { name, path } pairs (path WITHOUT leading slash for sub-pages, "" for home).
 */
export function buildBreadcrumbJsonLd(
  items: Array<{ name: string; path: string }>,
): string {
  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.name,
      item: `${CONTACT.websiteUrl}${item.path ? `/${item.path}` : ""}`,
    })),
  });
}
